export const hasPermission = (permission: string): boolean => {
  var permissions = []
  const permissionsString = localStorage.getItem('permissions')
  if (typeof permissionsString === 'string') {
    permissions = JSON.parse(permissionsString)
  }
  return permissions.indexOf(permission) != -1
}
